export default "__VITE_ASSET__Dio7H06G__"